<template>
    <v-app>
        <navbar title="Ares - Leads" :home="true" :type="menuType" :data="data" :attms="attms" :notts="notts" :mails="mails" :colorChoice="true" @actionClick="actionClick"/>
        <agentPref ref="agentPref"/>
    </v-app>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import agentPref from '@/components/pten/agentPref.vue';

    export default {
        components: {
            navbar,
            agentPref,
        },
        props: {
            menuIndex: {
                type: String,
                required: true,
            },
            menuType: {
                type: String,
                required: false,
                default: "pten"
            },
            data: {
                type: String,
                required: false,
                default: "",
            },
            attms: {
                type: Number,
                required: false,
                default: -1,
            },
            notts: {
                type: Number,
                required: false,
                default: -1,
            },
            mails: {
                type: Number,
                required: false,
                default: -1,
            },      
        },
        data() {
            return {
            }
        },
        mounted() {
            sessionStorage.setItem('menuIndex', this.menuIndex);
        },
        methods: { 
            actionClick(action) {
                switch (action) {
                    case "agentPrefs":
                        this.$refs.agentPref.openDialog(localStorage.getItem("login"));
                        break;
                
                    default:
                        this.$emit("actionClick", action);
                        break;
                }
            },
        }
    }
</script>

